import React, { useEffect, useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

import {
  Box, DashboardModule, FormField,
} from '@campaignhub/suit-theme'

import { useSetState, useDebounce } from '@campaignhub/react-hooks'
import useClientsV4 from '@hooks/useClientsV4'

import InfiniteLinkingTags from '@components/InfiniteLinkingTags'

const defaultState = {
  searchOfficeFilter: '',
}

const ClientAdminDetail = (props) => {
  const { userForm, customErrors } = props

  const [state, setState] = useSetState(defaultState)
  const { searchOfficeFilter } = state

  const {
    entityState: {
      client_admin,
    },
    setEntityState,
  } = userForm

  const debouncedSearchOfficeFilter = useDebounce(searchOfficeFilter, 300)

  const {
    filteredClientsV4,
    loading: clientLoading,
    hasMore: clientHasMore,
    callbacks: {
      loadNextPage: loadNextClientPage,
      loadInitialPage: loadInitialClientPage,
    },
  } = useClientsV4({ searchFilter: debouncedSearchOfficeFilter })

  useEffect(() => {
    loadInitialClientPage()
  }, [debouncedSearchOfficeFilter])

  const selectedCacheRef = useRef({})
  const linkedOffices = useMemo(() => {
    if (!client_admin?.offices?.length) return []
    return client_admin.offices.map((officeId) => {
      const fromPage = filteredClientsV4.find(client => client.id === officeId)
      if (fromPage) selectedCacheRef.current[officeId] = fromPage
      return selectedCacheRef.current[officeId] || { id: officeId, name: officeId }
    })
  }, [client_admin?.offices, filteredClientsV4])

  const toggleOffice = (office, type) => {
    let newList = []

    if (type === 'add'){
      selectedCacheRef.current[office.id] = office
      newList = [...linkedOffices, office]
    } else {
      newList = linkedOffices.filter(x => x.id !== office.id)
    }

    client_admin.offices = newList?.map(x => x.id) || []
    setEntityState({ client_admin })
  }

  return (
    <DashboardModule title="Client Admin Information">
      <Box flexDirection="column" padding="large">
        <Box
          flexDirection={['column', 'row']}
          marginBottom={[0, 'large']}
          width={['100%', 'calc(50% - 4px)']}
        >
          <FormField boxProps={{ flex: 1 }}>
            <InfiniteLinkingTags
              label="Offices"
              options={filteredClientsV4}
              selectedItems={linkedOffices}
              onSelect={item => toggleOffice(item, 'add')}
              onRemove={item => toggleOffice(item)}
              onLoadMore={loadNextClientPage}
              hasMore={clientHasMore}
              loading={clientLoading}
              placeholder="Search Offices"
              labelKey="name"
              valueKey="id"
              searchFilter={searchOfficeFilter}
              onSearchChange={val => setState({ searchOfficeFilter: val })}
              errorMessage={customErrors['client_admin.offices']}
            />
          </FormField>
        </Box>
      </Box>
    </DashboardModule>
  )
}

ClientAdminDetail.propTypes = {
  userForm: PropTypes.object,
  customErrors: PropTypes.array,
}

  export default ClientAdminDetail
